export enum PreloaderStatus {
    Idle,
    InProgress,
    Completed
}


/** WEBPACK FOOTER **
 ** ./Engine/Preloader/Types/PreloaderStatus.ts
 **/